import React, { useState } from 'react';

interface ExpandableTextProps {
  text: string;
  wordLimit: number;
}

const ExpandableText: React.FC<ExpandableTextProps> = ({ text, wordLimit }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const words = text.split(' ');
  const shouldTruncate = words.length > wordLimit;
  const displayedText = shouldTruncate && !isExpanded
    ? words.slice(0, wordLimit).join(' ') + '...'
    : text;

  return (
    <span>
      {displayedText}
      {shouldTruncate && (
        <button onClick={toggleExpand} style={{ marginLeft: '5px', color: '#06b681', cursor: 'pointer', background: 'none', border: 'none', padding: 0 }}>
          {isExpanded ? 'Show less' : 'Show more'}
        </button>
      )}
    </span>
  );
};

export default ExpandableText;